import api from '../../../services/api';

export const TimecardHTTP = {
  get: (params = {}) => api.get('/timecard/show', {params}),
};
